import(/* webpackMode: "eager", webpackExports: ["CaseStudiesPageContent"] */ "/vercel/path0/src/components/inbound-gpt/product-pages.tsx");
